

module.exports = function (fn) {
  var active = false, called = 0
  return function () {
    called = true
    if(!active) {
      active = true
      while(called) {
        called = false
        fn()
      }
      active = false
    }
  }
}











//////////////////
// WEBPACK FOOTER
// ./~/pull-write/~/looper/index.js
// module id = 791
// module chunks = 0